import { cx } from './utils'

export function LoadingState({
  label = 'Φόρτωση…',
  className,
}: {
  label?: string
  className?: string
}) {
  return (
    <p
      className={cx(
        'rounded-2xl border border-zinc-200 bg-white/80 px-4 py-8 text-center text-zinc-600 dark:border-zinc-800 dark:bg-zinc-900/60 dark:text-zinc-400',
        className,
      )}
    >
      {label}
    </p>
  )
}
